import { AxiosError } from "axios";
import { ADMIN_API_ENDPOINTS } from "@/config/apiEndpoints/adminUrls";
import { handleApiError } from "@/lib/utils";
import { UNIVERSITY_ID } from "@/constants/admin";
import adminAxios from "@/lib/axios";

export interface IUniversity {
  id?: number;
  name?: string;
  uni_code?: string;
  source?: string;
}

/**
 * Get university by ID
 */
export async function getUniversityById(id: number) {
  try {
    const response = await adminAxios.get(ADMIN_API_ENDPOINTS.UNIVERSITY.GET_CONTENT(id)
    );
    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

/**
 * Update university by ID.
 *
 * THROWS on failure, deliberately. This used to swallow the error and return a value, so a
 * REFUSED save still reached Form_1's success path and the admin was told "saved" while the
 * server had rejected the request. The admin API does reject on purpose — e.g. selecting a
 * lead CRM this server is not configured to reach — and that reason has to reach the screen.
 * Form_1 turns a thrown error into a destructive toast carrying this message.
 */
export async function updateUniversity(id: number, payload: Partial<IUniversity>) {
  try {
    const response = await adminAxios.put(ADMIN_API_ENDPOINTS.UNIVERSITY.UPDATE_INFO(id),
      payload
    );
    if (response?.status !== 200) {
      throw new Error("Failed to save university details");
    }
    return response.data;
  } catch (error) {
    const parsed = handleApiError(error as AxiosError); // keeps the existing console diagnostics
    const serverMessage =
      parsed?.message && parsed.message !== "Unknown error" ? parsed.message : null;
    throw new Error(
      serverMessage ||
        (error instanceof Error ? error.message : "Failed to save university details")
    );
  }
}

